module.exports = __webpack_public_path__ + "img/logo-AdN-blanc.22861338.png";